var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.403,
    height: 94.999,
    viewBox: "0 0 84.403 94.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442",
    transform: "translate(7694 16525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9112",
    "data-name": "Path 9112",
    d: "M0,461.52l16.963,16.952,8.112-8.214-16.7-17.2Z",
    transform: "translate(-7694 -16908.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9113",
    "data-name": "Path 9113",
    d: "M77.037,367.346l12.424,12.788,3.834-3.618s.751-.819,4.4-1.365,27.2-4.164,28.636-4.778,21.6-12.116,21.6-12.116,4.294-3.934-.887-7.475c-1.024-.7-2.776-.591-4.778.523s-16.946,8.368-16.946,8.368l-5.393-.12a5.139,5.139,0,0,1-3.851,2.765c-2.594.182-13.971.068-13.971.068s-1.65-1.092.347-1.638l14.011-.091s4.9-1.983,1.069-6.416c-1.161-1.342-17.537-2.981-22.077-2.708s-10.973,4.1-14.011,9.113a67.343,67.343,0,0,1-4.414,6.7",
    transform: "translate(-7759.205 -16821.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9114",
    "data-name": "Path 9114",
    d: "M147.111,336.181v-4.96l52.925-.091v3.39l-15.586,7.338h-4.505s.13-5.235-3.584-6.007c-3.956-.823-5.939-.649-18.413-2.116-3.816-.449-9.1,1.889-10.837,2.446",
    transform: "translate(-7818.516 -16805.271)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    width: 52.925,
    height: 5.097,
    transform: "translate(-7671.406 -16483.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9115",
    "data-name": "Path 9115",
    d: "M367.057,42.4l2.189,9.447a5.732,5.732,0,0,0-3.175,5l-11.929,2.4c.963-3.463.584-7.564-1.114-11.929a31.746,31.746,0,0,0-2.754-5.446l11.763-2.725a5.662,5.662,0,0,0,5.019,3.25",
    transform: "translate(-7990.476 -16558.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9116",
    "data-name": "Path 9116",
    d: "M145.745,23.743c-1.7-4.366-2.078-8.467-1.115-11.929l-11.929,2.4a5.727,5.727,0,0,1-3.175,5l2.19,9.449a5.66,5.66,0,0,1,5.018,3.25L148.5,29.189a31.871,31.871,0,0,1-2.754-5.446m0,0c-1.7-4.366-2.078-8.467-1.115-11.929l-11.929,2.4a5.727,5.727,0,0,1-3.175,5l2.19,9.449a5.66,5.66,0,0,1,5.018,3.25L148.5,29.189a31.871,31.871,0,0,1-2.754-5.446m37.176.513L178,2.119a2.716,2.716,0,0,0-3.23-2.055L125.214,11.078a2.713,2.713,0,0,0-2.055,3.228l4.918,22.137a2.716,2.716,0,0,0,3.23,2.055l49.56-11.014a2.714,2.714,0,0,0,2.055-3.228m-46.858,8.916-.161-.45a4.6,4.6,0,0,0-4.577-2.989l-.456.029-.1-.445-2.5-10.776.453-.16c3.05-1.077,2.926-4.442,2.918-4.585l-.022-.462.453-.092,14.174-2.849-.319.894c-2.944,8.242,3.821,17.842,3.889,17.938l.468.654ZM155.65,24.8l.074.393a1.322,1.322,0,1,1-2.6.485l-.041-.223a4.965,4.965,0,0,1-2.278-.465,1.323,1.323,0,1,1,.977-2.459c.014.006.026.012.04.017a2.6,2.6,0,0,0,1.06.267,5.137,5.137,0,0,0,.955-.127,1.5,1.5,0,0,0,1.227-1.511,1.07,1.07,0,0,0-1.02-1.112,11.836,11.836,0,0,1-3.491-.946,3.182,3.182,0,0,1-1.622-2.881,3.532,3.532,0,0,1,1.843-3.145l-.051-.267a1.323,1.323,0,0,1,2.6-.485l.043.227a4.4,4.4,0,0,1,1.487.41,1.323,1.323,0,0,1-1.169,2.374,1.81,1.81,0,0,0-1.662.071.913.913,0,0,0-.447.82.625.625,0,0,0,.2.531,9.983,9.983,0,0,0,2.677.679,3.72,3.72,0,0,1,3.256,3.677A4.208,4.208,0,0,1,155.65,24.8m22.115-5.253c-3.05,1.077-2.926,4.443-2.92,4.586l.023.461-.453.094-14.175,2.849.32-.9C163.5,18.407,156.739,8.8,156.67,8.7l-.468-.654L170.42,4.753l.163.45a4.658,4.658,0,0,0,4.576,2.99l.458-.032,2.6,11.223Zm-33.135-7.73-11.929,2.4a5.727,5.727,0,0,1-3.175,5l2.19,9.449a5.66,5.66,0,0,1,5.018,3.25L148.5,29.189a31.871,31.871,0,0,1-2.754-5.446c-1.7-4.366-2.078-8.467-1.115-11.929",
    transform: "translate(-7798.188 -16525)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetIcon);
export default __webpack_public_path__ + "static/media/net_icon.33269fcdaa78c513b89b0840379a2d20.svg";
export { ForwardRef as ReactComponent };